<ng-container [formGroup]="formGroup">
    <div class="table-row row gx-2 gy-0 p-2">
        <div class="col-12 text-center fw-semibold py-1">{{ document.title }}</div>
        <div class="col-auto">
            <div class="checkbox-container">
                <input
                    type="checkbox"
                    class="form-control"
                    #checkbox
                    id="document-select-checkbox"
                    formControlName="checkbox"
                    (click)="selectDocument()"
                    [attr.aria-label]="'DOCBOX_SELECT_DOC_ARIA_LABEL' | translate"
                />
                @if (document.isFileSelected) {
                    <fa-icon [icon]="faCheck" size="2x" (click)="checkbox.click()"></fa-icon>
                }
            </div>
            <div class="text-center py-3" (click)="toggleExpanded()">
                @if (!isExpanded) {
                    <fa-icon [icon]="faChevronRight"></fa-icon>
                }
                @if (isExpanded) {
                    <fa-icon [icon]="faChevronDown"></fa-icon>
                }
            </div>
        </div>
        <div class="col">
            <div class="g-2 row">
                <div class="col-6">
                    @if (document.docType) {
                        <span class="type-icon">
                            <fa-icon [icon]="document.docType | docBoxListIcon"></fa-icon>
                        </span>
                    }
                    {{ document.docType }}
                </div>
                @if (document.date) {
                    <div class="col-6">{{ document.date }}</div>
                }
                @if (document.createdBy) {
                    <div class="col-12 col-sm-6 col-lg-4">{{ document.createdBy }}</div>
                }
                @if (document.reportStatus) {
                    <div class="col-12 col-sm-6 col-lg-4">
                        <span class="me-2 col-form-label" translate="DOCBOX_REPORT_STATUS_LABEL"></span>
                        {{ document.reportStatus }}
                    </div>
                }
                @if (document.printNumber && isExpanded) {
                    <div class="col-12 col-sm-6 col-lg-4">
                        {{ document.printNumber }}
                    </div>
                }
                @if (document.orderNumber && isExpanded) {
                    <div class="col-12 col-sm-6 col-lg-4">
                        {{ document.orderNumber }}
                    </div>
                }
                @if (document.fileType && isExpanded) {
                    <div class="col-12 col-sm-6 col-lg-4">
                        {{ document.fileType }}
                    </div>
                }
            </div>
        </div>
        <div class="col-auto d-flex flex-column gap-2">
            @if (enableIndividualDownload) {
                <button
                    class="btn btn-small btn-secondary"
                    (click)="downloadDocument()"
                    [attr.aria-label]="'DOCBOX_DOWNLOAD_DOCUMENT_TOOLTIP' | translate"
                >
                    <fa-icon [icon]="faSave"></fa-icon>
                </button>
            }
            <button
                class="btn btn-small btn-secondary"
                placement="left"
                (click)="uploadForEntry()"
                [attr.aria-label]="'DOCBOX_UPLOAD_DOCUMENT_TOOLTIP' | translate"
            >
                <fa-icon [icon]="faCloudUploadAlt"></fa-icon>
            </button>
        </div>
    </div>
</ng-container>
